// Performance monitoring utilities
export const measurePerformance = () => {
  if (typeof window !== 'undefined' && window.performance) {
    const perfData = window.performance.getEntriesByType('navigation')[0];
    
    if (perfData) {
      const metrics = {
        // Core Web Vitals
        FCP: perfData.responseEnd - perfData.fetchStart, // First Contentful Paint
        LCP: 0, // Will be measured separately
        FID: 0, // Will be measured separately
        CLS: 0, // Will be measured separately
        
        // Navigation Timing
        DNS: perfData.domainLookupEnd - perfData.domainLookupStart,
        TCP: perfData.connectEnd - perfData.connectStart,
        SSL: perfData.requestStart - perfData.secureConnectionStart,
        TTFB: perfData.responseStart - perfData.fetchStart,
        Download: perfData.responseEnd - perfData.responseStart,
        DOMInteractive: perfData.domInteractive - perfData.fetchStart,
        DOMComplete: perfData.domComplete - perfData.fetchStart,
        LoadComplete: perfData.loadEventEnd - perfData.fetchStart,
      };
      
      // Log to console in development
      if (import.meta.env.DEV) {
        console.table(metrics);
      }
      
      return metrics;
    }
  }
  return null;
};

// Lazy load images with Intersection Observer
export const lazyLoadImages = () => {
  const images = document.querySelectorAll('img[data-src]');
  
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        observer.unobserve(img);
      }
    });
  }, {
    rootMargin: '50px 0px',
    threshold: 0.01
  });
  
  images.forEach(img => imageObserver.observe(img));
};

// Optimize scroll performance
export const optimizeScroll = () => {
  let ticking = false;
  
  function updateScrollProgress() {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrolled = (winScroll / height) * 100;
    
    // Update progress bar
    const progressBar = document.querySelector('.progress-bar');
    if (progressBar) {
      progressBar.style.width = scrolled + '%';
    }
    
    ticking = false;
  }
  
  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollProgress);
      ticking = true;
    }
  }
  
  window.addEventListener('scroll', requestTick, { passive: true });
};

// Preconnect to external domains
export const preconnectDomains = () => {
  const domains = [
    'https://resty.store',
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com'
  ];
  
  domains.forEach(domain => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = domain;
    document.head.appendChild(link);
  });
};

// Initialize all performance optimizations
export const initPerformanceOptimizations = () => {
  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      lazyLoadImages();
      optimizeScroll();
      preconnectDomains();
      measurePerformance();
    });
  } else {
    lazyLoadImages();
    optimizeScroll();
    preconnectDomains();
    measurePerformance();
  }
};